module.exports = eval("try{require('crypto')}catch(e){}");